import server from "./server";

export const getAllApplicationsApi = async (searchParams) => {
    const response = await server().get(
        `/partners/applications/?${searchParams}`
    );

    return response.data;
};

export const addApplicationApi = async (data) => {
    const response = await server().post("/partners/applications", data);

    return response.data;
};

export const getApplicationApi = async (id) => {
    const response = await server().get(`/partners/applications/${id}`);

    return response.data;
};

export const editApplicationApi = async ({ id, data, endpointName }) => {
    const response = await server().put(
        `/partners/applications/${id}/${endpointName}`,
        data
    );

    return response.data;
};

export const deleteApplicationApi = async (id) => {
    const response = await server().delete(`/partners/applications/${id}`);

    return response.data;
};

export const refreshClientTokenApi = async (id) => {
    const response = await server().put(
        `/partners/applications/refreshToken/${id}`
    );

    return response.data;
};
